module.exports = __webpack_public_path__ + "img/Speaker=John Weigelt.4980a44a.png";